<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>设备编码:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="query.assertsCode"></lk-input>
          </div>
          <div class="queryItem">
            <label>购置时间:</label>
            <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.duration' />
          </div>
          <div class="queryItem">
            <label>设备名称:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim='query.name'></lk-input>
          </div>
          <div class="queryItem">
            <label>设备型号:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim='query.unitType'></lk-input>
          </div>
          <div class="queryItem">
            <label>设备分类:</label>
            <lk-select class="item" clearable v-model.trim='query.category'>
              <lk-option v-for="item in assetsCategory" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>设备类型:</label>
            <lk-select class="item" clearable v-model.trim='query.typeId'>
              <lk-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>使用状态:</label>
            <lk-select class="item" clearable v-model.trim='query.status'>
              <lk-option v-for="item in assetsStatus" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' icon='md-add' @click="$router.push({ name:'assetsCommonAdd' });" v-if="handlePermission('assetsCommonAdd')">录入普通设备</lk-button>
          <lk-button type='primary' icon='md-add' @click="$router.push({ name:'assetsMeteringAdd', params: { type: 'metering' } });" v-if="handlePermission('assetsMeteringAdd')">录入计量设备</lk-button>
          <lk-button type='primary' icon='md-add' @click="$router.push({ name:'assetsMeteringAdd', params: { type: 'cold' } });" v-if="handlePermission('assetsColdStorageAdd')">录入冷藏储存设备</lk-button>
          <lk-button type='primary' :disabled="this.selection.length > 0 ? false : true" @click="carringForward" v-if="handlePermission('assetsCarryingForward')">生成结转凭证</lk-button>
          <!--<lk-button type='primary' :disabled="this.selection.length > 0 ? false : true" @click="curingAssets">养护</lk-button>-->
        </div>
        <lk-table border :columns="columns" :data="tableData" @on-selection-change="onSelectionChange"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
// import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import assets from '../../services/assets';
import system from '../../services/system';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
// 鉴权
export default {
  mixins: [mapState, queryMixins],
  data() {
    return {
      columns: [
        { title: '选择', type: 'selection', width: 60 },
        { title: '设备编码', key: 'assertsCode', minWidth: 125 },
        { title: '设备名称', key: 'name', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '设备型号', key: 'unitType', minWidth: 116 },
        {
          title: '设备分类',
          key: 'category',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.category === 1) {
              return h('span', '办公用品');
            } if (params.row.category === 2) {
              return h('span', '药品养护设备');
            } if (params.row.category === 3) {
              return h('span', '计量器具');
            } if (params.row.category === 4) {
              return h('span', '冷藏储存设备');
            }
            return h('span', '');
          },
        },
        { title: '设备类型', key: 'typeName', minWidth: 116 },
        {
          title: '购置时间',
          key: 'acquisitionTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.acquisitionTime)),
        },
        { title: '购置价格', key: 'acquisitionPrice', minWidth: 116 },
        { title: '使用期限(月)', key: 'serviceLife', minWidth: 120 },
        { title: '放置地点', key: 'placement', minWidth: 116 },
        { title: '用途', key: 'purpose', minWidth: 116 },
        { title: '录入人', key: 'createUserName', minWidth: 116 },
        { title: '养护员', key: 'curingUserName', minWidth: 116 },
        {
          title: '使用状态',
          key: 'status',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.status === 1) {
              return h('span', '在用');
            } if (params.row.status === 2) {
              return h('span', '停用');
            } if (params.row.status === 3) {
              return h('span', '封存');
            } if (params.row.status === 4) {
              return h('span', '报废');
            }
            return h('span', '-');
          },
        },
        { title: '已结转期数', key: 'carryingForwardTimes', minWidth: 116 },
        { title: '备注', key: 'description', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('assetsInfoCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',

              },
              on: {
                click: () => {
                  // 查看设备详情,
                  this.$router.push({ name: 'assetsInfoCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,

            this.handlePermission('assetsInfoEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.status === 4,
              },
              on: {
                click: () => {
                  // 编辑设备信息,
                  this.$router.push({ name: 'assetsInfoEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
      query: {
        storeIdList: [], // 门店名称
        assertsCode: '', // 设备编码
        duration: [],
        acquisitionStartTime: '', // 购置开始时间
        acquisitionEndTime: '', // 购置结束时间
        name: '', // 设备名称
        unitType: '', // 设备型号
        category: '', // 设备分类
        typeId: '', // 设备类型
        status: '', // 使用状态
      },
      assetsStatus: [
        { id: 1, name: '在用' },
        { id: 2, name: '停用' },
        { id: 3, name: '封存' },
        { id: 4, name: '报废' },
      ],
      assetsCategory: [
        { id: 1, name: '办公设备' },
        { id: 2, name: '药品养护设备' },
        { id: 3, name: '计量器具' },
        { id: 4, name: '冷藏储存设备' },
      ],
      disablePage: false,
      storeList: [],
      typeList: [],
      curingUserList: [],
      selection: [],
    };
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length === 2) {
        this.params.acquisitionStartTime = this.params.duration[0];
        this.params.acquisitionEndTime = this.params.duration[1];
        delete this.params.duration;
      }
      assets.assetsList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            // item.acquisitionPrice = utils.exchangePercent(item.acquisitionPrice);
            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getTypeList() {
      assets.typeList().then((res) => {
        if (res.data.status === 200) {
          this.typeList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStoreList() {
      system.getBelongStores().then((res) => {
        if (res.data.status === 200) {
          this.storeList = res.data.data;
        }
      });
    },
    clear() {
      this.query = {};
    },
    onSelectionChange(selection) {
      this.selection = selection;
    },
    carringForward() {
      const assertsIds = [];
      this.selection.forEach((item) => {
        assertsIds.push(item.id);
      });
      assets.assetsCarringForward({ assertsIds }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data) {
            const info = res.data.data;
            // 生产结转凭证的列表中有本月已经结转过的，非本月结转的，已结转期数要进行++;
            this.tableData.forEach((item) => {
              if (assertsIds.includes(item.id) && !info.includes(item.assertsCode)) {
                this.$set(item, 'carryingForwardTimes', item.carryingForwardTimes + 1);
              }
            });
            this.$Message.info(res.data.data);
          } else {
            this.$Message.info('生成结转凭证成功');
          }
          console.log(res.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  created() {
    this.getTypeList();
    this.getStoreList();

    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
  components: {
    QueryFrame,
    // timeStampDatePicker,
  },
  computed: {
    currentUserRoleType() {
      const currentRoleIds = [];
      this.$store.state.user.roles.forEach((item) => {
        currentRoleIds.push(item.type);
      });
      if (!currentRoleIds.includes(2)) { // 门店管理员
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
  .btns{
    display: flex;
    // justify-content: space-between;
    margin-bottom: 12px;
    // padding-top: 16px;
    div:last-child>*{
      margin-left: 16px
    }
    >*{
      margin-right: 16px
    }
  }
</style>
